import './app/publicPath'

// import ApiService from '../../../../Ceres/resources/js/src/app/services/ApiService'
// window.ApiService = ApiService

const Vue = window.Vue

Vue.component('ItemCrossSelling', () => import('./app/components/item/ItemCrossSelling.vue'))
Vue.component('BasketCrossSelling', () => import('./app/components/basket/BasketCrossSelling.vue'))
Vue.component('item-filter-list', () => import('./app/components/itemList/filter/ItemFilterList.vue'))